/// <reference types="jquery" />

type ViewContentCallback = (content: unknown) => void;
type AjaxPayload = string | JQuery.PlainObject<unknown> | undefined;

jQuery(function ()
{
    $(document.documentElement).removeClass('noscript');
    $("#popupNotification").data("kendoNotification");
});

function getViewContent(
    route: string,
    target: string,
    callback: ViewContentCallback | null = null)
{
    const targetItem = jQuery(target);

    jQuery.ajax({
        method: "GET",
        url: route
    })
        .done(function (content)
        {
            targetItem.html(content);

            if (callback !== null)
            {
                callback(content);
            }
        });
}

function postViewContentBase(
    route: string,
    contentType: string,
    params: AjaxPayload,
    target: string,
    callback: ViewContentCallback | null = null)
{
    const targetItem = jQuery(target);

    jQuery.ajax({
        method: 'POST',
        url: route,
        contentType: contentType,
        data: params
    })
        .done(function (content)
        {
            targetItem.html(content);

            if (callback !== null)
            {
                callback(content);
            }
        });
}

function postViewContent(
    route: string,
    params: JQuery.PlainObject<unknown> | undefined,
    target: string,
    callback: ViewContentCallback | null = null)
{
    postViewContentBase(
        route,
        "application/x-www-form-urlencoded; charset=UTF-8",
        params,
        target,
        callback);
}

function postJsonViewContent(
    route: string,
    params: JQuery.PlainObject<unknown> | undefined,
    target: string,
    callback: ViewContentCallback | null = null)
{
    const jsonParams = JSON.stringify(params);
    postViewContentBase(route, "application/json", jsonParams, target, callback);
}

function spinButton(button: HTMLButtonElement, originalClass: string)
{
    $(button).find('[data-fa-i2svg]')
        .removeClass(originalClass)
        .addClass('fa-spinner fa-spin')
        .attr('data-prefix', 'fa');
}

function unspinButton(button: HTMLButtonElement, originalClass: string)
{
    $(button).find('[data-fa-i2svg]')
        .addClass(originalClass)
        .removeClass('fa-spinner fa-spin')
        .attr('data-prefix', 'fa');
}

interface CustomerPortalUtilities
{
    getViewContent: typeof getViewContent;
    postViewContent: typeof postViewContent;
    postJsonViewContent: typeof postJsonViewContent;
    spinButton: typeof spinButton;
    unspinButton: typeof unspinButton;
}

interface CustomerPortalWindow
{
    utilities?: CustomerPortalUtilities;
}

interface Window
{
    CustomerPortal?: CustomerPortalWindow;
    getViewContent: typeof getViewContent;
    postViewContent: typeof postViewContent;
    postJsonViewContent: typeof postJsonViewContent;
    spinButton: typeof spinButton;
    unspinButton: typeof unspinButton;
}

window.CustomerPortal ??= {};
window.CustomerPortal.utilities = {
    getViewContent,
    postViewContent,
    postJsonViewContent,
    spinButton,
    unspinButton
};

window.getViewContent = getViewContent;
window.postViewContent = postViewContent;
window.postJsonViewContent = postJsonViewContent;
window.spinButton = spinButton;
window.unspinButton = unspinButton;